import { useEffect, useMemo, useState } from 'react'
import {
  DELIVERY_STATUS_DIC,
  DELIVERY_TYPES_UI,
  ON_BOARD_SALE
} from './constants/constants'
import TabWithDropdown from '../layout/TabWithDropdown'
import DeliveryDetailsTab from './DeliveryDetailsTab'

const ShowDeliveryView = ({ details, defaultDetails }) => {
  const [activity, setActivity] = useState(defaultDetails)

  useEffect(() => {
    setActivity(defaultDetails)
  }, [defaultDetails])

  const deliveryStatus = useMemo(() => {
    if (!activity) return null
    return (
      DELIVERY_STATUS_DIC[activity.delivery_type] || DELIVERY_STATUS_DIC[activity.status] || null
    )
  }, [activity])

  const isOnBoardSale = activity?.delivery_type === ON_BOARD_SALE.key
  const typeKey = isOnBoardSale ? 'on_board_sale' : 'normal'
  const { name: typeName, shortName: typeShortName } = DELIVERY_TYPES_UI[typeKey]

  const title = `${typeName}: ${activity?.uid}`
  const tabName = typeShortName

  return (
    <>
      <div className="main-show-header">
        <h2>{title}</h2>
      </div>

      <div className="index-table">
        <div className="show-area">
          <div className="status-orders">
            <b className="order-status-b">Estado:</b>
            {deliveryStatus && (
              <span className={`order-status ${deliveryStatus.className}`}>
                {deliveryStatus.label}
              </span>
            )}
          </div>

          {['received', 'sent', 'open', 'to_be_assigned'].includes(activity?.status) && (
            <ul className="nav nav-tabs">
              <TabWithDropdown name={tabName} activeTab={tabName} items={[]} />
            </ul>
          )}

          <DeliveryDetailsTab activity={activity} transactionUuid={details?.uuid} />
        </div>
      </div>
    </>
  )
}

export default ShowDeliveryView
